import { asyncMenu } from '@/api/menu'

const routerListArr = []
const notLayoutRouterArr = []


const state = {
  baseRouter: [],
  routeMap:{}
}

const mutations = {
  SET_BASE_ROUTER: (state, baseRouter) => {
    state.baseRouter = baseRouter
  },
  SET_ROUTE_MAP: (state, routeMap) => {
    state.routeMap = routeMap
  },
}

const actions = {
  SetAsyncRouter({ commit }) {
    let asyncRouter = []
    const baseRouter = [{
      path: '/layout',
      name: 'layout',
      component: 'view/layout/index.vue',
      meta: {
        title: '底层layout'
      },
      children: []
    }]
    return new Promise((resolve, reject) => {
      asyncMenu().then(res => {
        asyncRouter = res.data.menus
        asyncRouter && asyncRouter.push({
          path: '404',
          name: '404',
          hidden: true,
          meta: {
            title: '迷路了*。*',
            closeTab: true,
          },
          component: 'view/error/index.vue'
        }, {
          path: 'reload',
          name: 'Reload',
          hidden: true,
          meta: {
            title: '',
            closeTab: true,
          },
          component: 'view/error/reload.vue'
        })
        formatRouter(asyncRouter, state.routeMap)
        baseRouter[0].children = asyncRouter
        if (notLayoutRouterArr.length !== 0) {
          baseRouter.push(...notLayoutRouterArr)
        }
        baseRouter.push({
          path: '/:catchAll(.*)',
          redirect: '/layout/404'
        })
        commit('SET_BASE_ROUTER',baseRouter)
        resolve(baseRouter)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const formatRouter = (routes, routeMap) => {
  routes && routes.forEach(item => {
    if ((!item.children || item.children.every(ch => ch.hidden)) && item.name !== '404' && !item.hidden) {
      routerListArr.push({ label: item.meta.title, value: item.name })
    }
    item.meta.btns = item.btns
    item.meta.hidden = item.hidden
    if (item.meta.defaultMenu === true) {
      notLayoutRouterArr.push({
        ...item,
        path: `/${item.path}`,
      })
    } else {
      routeMap[item.name] = item
      if (item.children && item.children.length > 0) {
        formatRouter(item.children, routeMap)
      }
    }
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/router.js